<template>
    <Page :header="content[lang_].title" :header_pos="'center'">
        <template #body>
            <div v-if="!isTgApp" class="flex flex-row w-full align-items-center justify-content-center">
                <Button :label="content[lang_].main" @click="go_main" class="border-round-lg" severity="info" />
                <Divider v-if="!isLoggedIn" layout="vertical" align="center"/>
                <Button v-if="!isLoggedIn" :label="content[lang_].login" @click="go_auth" class="border-round-lg" text severity="info" />
            </div>
            <div v-else class="flex flex-column w-full align-items-center justify-content-center text-center gap-3">
                <span class="flex text-700">{{content[lang_].enterTg}}</span>
                <Button :label="content[lang_].btn" @click="loginWithTelegram()" class="flex"/>
            </div>
        </template>
    </Page>
</template>


<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import Event from '@/assets/js/Event'
import { mapActions } from "vuex"
import Page from '@/components/sides/Page.vue'

export default {
    data() {
        return {
            isTgApp: false,
            isLoading: false,
            content:{
                en: {
                    title: "Access denied",
                    main: "Main",
                    login: "Login",
                    regBtn: "Registration",
                    loginTg: "Login with Telegram",
                    enterTg: "Session expired. Please login close and open Telegram app and try again.",
                    btn: "Login",
                    error: "Error",
                    errMsg: 'This is not a Telegram App',
                    authBtn: "Login",
                } ,
                ru: {
                    title: "Доступ запрещен",
                    main: "Главная",
                    login: "Войти",
                    regBtn: "Регистрация",
                    loginTg: "Войти через Telegram",
                    enterTg: "Сеанс истек. Пожалуйста, авторизуйтесь повторно",
                    btn: "Авторизоваться",
                    error: "Ошибка",
                    errMsg: 'Это не приложение Telegram'
                }
            },
        }
    },
    components: {
        Page
    },
    methods: {
        go_main(){
            this.$router.push({
                path: '/'
            })
        },
        go_auth(){
            this.$router.push({
                path: '/auth/'
            })
        },
        ...mapActions(['ActionWebAppTgLogin', 'SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        async loginWithTelegram(){

            const raw_obj = (window && window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData) ? window.Telegram.WebApp.initData : null
            if(!raw_obj) {
                this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].errMsg)
                return
            }

            this.isLoading = true
            this.event.send('authDo')

            const ref_store = this.$store.getters.StateRef
            const ref_localstorage = localStorage.getItem('ref')
            const ref = (ref_store) ? ref_store : (ref_localstorage) ? ref_localstorage : null

            try {
                const login = await this.ActionWebAppTgLogin({user: raw_obj, ref: ref}).then(res=>res)
                if(login.result && login.data){
                    this.event.send('authSuccess')
                    this.isLoading = false
                    this.$router.push({ path: '/' })
                } else {
                    this.isLoading = false
                    if(login.errors) {
                        for (let i = 0; i < login.errors.length; i++) {
                            this.showMess('error', 'Error', login.errors[i])
                        }
                    } else {
                        this.showMess('error', 'Error', 'Authorisation Error 2')
                    }
                }
            } catch (error) {
                console.log('error', error)
                this.showMess('error', 'Error', 'Authorisation Error 2')
                this.isLoading = false
            }
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        },
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
        isTgApp: function () { return this.$store.getters.StateTgApp },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)
    },
    mounted() {
		if(!this.isLoggedIn){
			try {
				this.SetHeaderTitle(null)
				this.SetHeaderBtnLeftFirst({
					type: 'link',
					link: '/auth/',
					label: this.content[this.lang_].login,
					icon: 'pi pi-sign-in',
					iconPos: 'right',
					severity: 'secondary',
					class: '',
					rounded: true,
					visible: true
				})
				this.SetHeaderBtnLeftSecond({})
				this.SetHeaderBtnRightFirst({
					type: 'link',
					link: '/reg/',
					label: this.content[this.lang_].regBtn,
					icon: 'pi pi-user-plus',
					iconPos: 'right',
					severity: 'primary',
					class: 'text-green-500',
					rounded: true,
					visible: true
				})
				this.SetHeaderBtnRightSecond({})
			} catch (error) {
				console.error('Error setting header:', error)
			}
		}
	}
}
</script>